// src/components/Dashboard/StatCardGlow.jsx
import React from 'react';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';

export const StatCardGlow = ({ title, value, unit, icon }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.015, transition: { duration: 0.2 } }}
      className="
        relative p-6 rounded-2xl
        bg-white dark:bg-gray-900
        border border-gray-200 dark:border-gray-800
        shadow-sm hover:shadow-md
        transition-all
      "
    >
      {/* Icon badge */}
      <div
        className="
          absolute -top-3 -right-3 p-3 rounded-xl shadow-sm
          bg-fundo-green-50 text-fundo-green-700
          dark:bg-fundo-green-900 dark:text-fundo-green-300
          border dark:border-gray-700
        "
      >
        {icon}
      </div>

      {/* Title */}
      <p className="text-gray-500 dark:text-gray-400 text-sm">{title}</p>

      {/* Value */}
      <h3 className="text-4xl font-bold text-gray-900 dark:text-white mt-1 flex items-baseline gap-2">
        <CountUp end={value} duration={1.2} />
        {unit && <span className="text-lg text-gray-500 dark:text-gray-400">{unit}</span>}
      </h3>

      {/* Progress hint */}
      <div className="mt-4 w-full bg-gray-200/60 dark:bg-gray-700 h-1 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(value, 100)}%` }}
          transition={{ duration: 1.2 }}
          className="h-full bg-fundo-green-600 dark:bg-fundo-green-400"
        />
      </div>
    </motion.div>
  );
};
